import { render, staticRenderFns } from "./ReleaseAudit.vue?vue&type=template&id=4dcfc190&scoped=true"
import script from "./ReleaseAudit.vue?vue&type=script&lang=ts"
export * from "./ReleaseAudit.vue?vue&type=script&lang=ts"
import style0 from "./ReleaseAudit.vue?vue&type=style&index=0&id=4dcfc190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcfc190",
  null
  
)

export default component.exports